import gql from 'graphql-tag';

export const SYNC_ADVERTISER_WITH_SHOPIFY = gql`
  mutation SyncAdvertiser {
    syncAdvertiserWithShopify
  }
`;
